import { ReactElement } from "react";
import "./index.css";

interface IProps {
  title: string;
  url: string;
  border?: boolean;
}

export function StoryLineItem(props: IProps): ReactElement {
  let slItemActive = "storyLineItem";
  if (props.border) {
    slItemActive = slItemActive + " storyLineItem-active";
  }
  const normalizedUrl = String(props.url || "").replace(/\\/g, "/");
  
  return (
    <div className={slItemActive}>
      <div
        className="storyLineItem_image"
        style={{ backgroundImage: `url(${normalizedUrl})` }}
      >

        <div className="storyLineItem_mask">
          <span className="storyLineItem_text">{props.title}</span>
        </div>
      </div>
    </div>
  );
}
